import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { IButton } from '../uiParts/buttons'
import { buttons } from '../uiParts/buttons-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'

interface ISpeedButton {
  button: IButton
  speed: number
}
interface IData {
  isOpen: boolean
  buttons: ISpeedButton[]
  // textMode: IStevieText
  lastSpeed: number
}
let _data: IData | null = null

export const getData = () => {
  if (!_data) {
    let ctx = scene.getContext()

    let y = 60 - 22
    let x = 0

    // let text = stevieText.create(ctx.font24, x, y + 7)
    // stevieText.setText(text, 'Speed')
    let btns: ISpeedButton[] = []
    let bw = 80
    // x += bw

    const addButton = (text: string, speed: number) => {
      let button = buttons.create(layers.getLayers().ui, x, y, text, () => {
        clickEater.tempEat()
        setSpeed(speed)
      })
      x += bw
      let sb: ISpeedButton = {
        speed,
        button,
      }
      btns.push(sb)
    }
    addButton('Pause', 0)
    addButton('0.5x', 0.5)
    addButton('1x', 1)
    addButton('2x', 2)
    addButton('4x', 4)
    addButton('8x', 8)
    addButton('16x', 16)
    _data = {
      isOpen: true,
      buttons: btns,
      // textMode: text,
      lastSpeed: 1,
    }
    setOpen(false)
  }
  return _data
}

export const setSpeed = (speed: number) => {
  let ctx = scene.getContext()
  ctx.speedScale = speed
  if (speed !== 0) {
    let d = getData()
    d.lastSpeed = speed
  }
}

export const setOpen = (isOpen: boolean) => {
  let data = getData()
  data.isOpen = isOpen
  l.forEach(data.buttons, (c, cIdx) => {
    buttons.setVisible(c.button, isOpen)
  })
  // stevieText.setVisible(data.textMode, isOpen)
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()

  let data = getData()
  if (data.isOpen) {
    // stevieText.setText(data.textMode, '' + ctx.speedScale.toFixed(1))

    l.forEach(data.buttons, (c) => {
      buttons.setSelected(c.button, ctx.speedScale === c.speed)
    })
  }
}

export const togglePause = () => {
  let data = getData()
  let ctx = scene.getContext()

  // console.log('toggle pause', ctx.speedScale)

  if (ctx.speedScale !== 0) {
    setSpeed(0)
  } else {
    setSpeed(data.lastSpeed)
  }
}
